import { api } from './api';

const fetchReservationRulesets = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get('/reservation/rules_set', payload, options);
};

const fetchReservationRulesetById = (id) => {
  return api.get(`/reservation/rules_set/${id}`);
};

const createReservationRuleset = (params) => {
  return api.post(`/reservation/rules_set`, params);
};

const updateReservationRuleset = (id, params) => {
  return api.post(`/reservation/rules_set/${id}/overwrite`, params);
};

const deleteReservationRuleset = (id) => {
  return api.delete(`/reservation/rules_set/${id}`);
};

export {
  fetchReservationRulesets,
  fetchReservationRulesetById,
  createReservationRuleset,
  updateReservationRuleset,
  deleteReservationRuleset,
};
